module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Configuration File")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px",
      "label-suffix": "："
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.configurationFile
    }
  }, [_vm._v(" agent_config.yaml ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.updateTime
    }
  }, [(_vm.connects) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((_vm.addForm.update_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn flex items-center",
    staticStyle: {
      "justify-content": "space-around"
    },
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isPolling),
      expression: "isPolling"
    }],
    attrs: {
      "disabled": _vm.isPolling,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.toExport()
      }
    }
  }, [_c('translate', [_vm._v("Export")])], 1), _vm._v(" "), (_vm.connects) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "disabled": _vm.isPolling,
      "action": ((_vm.baseUrl.apiUrl) + "/agent/config/import"),
      "data": {
        network_id: _vm.connects.info.id
      },
      "show-file-list": false,
      "on-success": _vm.importAndRestart,
      "on-error": _vm.importError,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isPolling),
      expression: "isPolling"
    }],
    attrs: {
      "size": "primary",
      "type": "primary"
    }
  }, [_c('translate', [_vm._v("Import And Restart")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ef517c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/cluster-config-file.vue
// module id = 555
// module chunks = 4 5 6